import { ref } from 'vue';

import { YoukaiArticles } from '../types';

import { useGetYoukaiArticles } from '../api';

const useStatus = () => {
  const posts = ref<YoukaiArticles>([]);
  const offset = ref(0);
  const totalCount = ref<number | null>(null);
  const canFetch = ref(true);
  const isLoading = ref(true);
  const isError = ref(false);
  const fetchUrl = ref<string | null>(null);

  const parentCategoryId = ref<string | null>(null);
  const parentCategorySlug = ref<string | null>(null);
  const parentCategoryName = ref<string | null>(null);

  const init = () => {
    posts.value = [];
    offset.value = 0;
    totalCount.value = null;
    canFetch.value = true;
    isLoading.value = true;
    isError.value = false;
    fetchUrl.value = null;

    parentCategoryId.value = null;
    parentCategorySlug.value = null;
    parentCategoryName.value = null;
  };

  return {
    posts,
    offset,
    totalCount,
    canFetch,
    isLoading,
    isError,
    fetchUrl,
    parentCategoryId,
    parentCategorySlug,
    parentCategoryName,
    init,
  };
};

export const useArticles = () => {
  const {
    posts,
    offset,
    totalCount,
    canFetch,
    isLoading,
    isError,
    fetchUrl,
    parentCategoryId,
    parentCategorySlug,
    parentCategoryName,
    init,
  } = useStatus();

  const fetchPosts = async (url: string) => {
    isLoading.value = true;

    if (fetchUrl.value !== url) {
      init();
    }
    fetchUrl.value = url;

    const response = await useGetYoukaiArticles({ url, offset: offset.value });
    if (response) {
      const {
        articles,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        max_articles_count,
        parent,
      } = response;

      const setParentData = () => {
        if (!parent) return;
        parentCategoryId.value = parent.id;
        parentCategorySlug.value = parent.slug;
        parentCategoryName.value = parent.name;
      };

      posts.value = [...posts.value, ...articles];
      totalCount.value = max_articles_count;
      offset.value += articles.length;
      canFetch.value = totalCount.value > offset.value;
      setParentData();
    } else {
      isError.value = true;
    }
    isLoading.value = false;
  };

  return {
    posts,
    totalCount,
    canFetch,
    isLoading,
    isError,
    fetchPosts,
    parentCategoryId,
    parentCategorySlug,
    parentCategoryName,
  };
};
